import React from 'react';
import styles from './HighlightCard.module.scss';
import { HomeHighlight } from '../../../../../types/home.types';
import { Routes } from '../../../../../types/constants';

interface HighlightCardProps {
    highlight: HomeHighlight;
}

const HighlightCard = ({ highlight }: HighlightCardProps) => {
    return (
        <a className={styles.card} href={`${Routes.WATCH}?v=${highlight.videoUri}`} role="listitem">
            <img src={highlight.imageUrl} alt={highlight.title} className={styles.image} />
            <div className={styles.content}>
                <span className={styles.tag}>Now streaming</span>
                <h3 className={styles.title}>{highlight.title}</h3>
                <p className={styles.description}>{highlight.description}</p>
                <span className={styles.cta}>Watch now</span>
            </div>
        </a>
    );
};

export default HighlightCard;
